module.exports = __webpack_public_path__ + "img/notfound.67a38599.png";